import React from 'react';
import { Spacer, PageContent, Query, ContentBoxContainer, ContentBoxText, ContentBoxFigure, PenlySeo } from 'components';
import { mediaQueries, fromTablethoriMediaQuery } from 'utils/MediaQueriesDeprecated';
// import ABOUT_PAGE_QUERY from 'queries/pages/about';

export default function OmPenly() {
    const title = 'Om Penly';
    const description = 'Penly er til for dig som privatforbruger. Vi vil inspirere og hjælpe dig til at blive klogere på din økonomiske situation og dine muligheder.';
    const image = { url: '/static/gfx/PenlyFamily/ThePenlyFamily.jpg' };
    const fromTablethori = mediaQueries(fromTablethoriMediaQuery);

    return (
        <>
            <PenlySeo title={ title } description={ description } image={ image } />
            { /*
            <Query query={ ABOUT_PAGE_QUERY }>
                { ({ data: { about } }) => {
                    return <PageContent { ...about.content } centerImage />;
                } }
            </Query>
            */ }

            <ContentBoxContainer className="mobileflip">
                <ContentBoxText>
                    <h1 className="nomb color-primary">VI VIL GØRE EN FORSKEL FOR DIG</h1>
                    <Spacer />
                    <p>
                        I mere ed 20 år har vi arbejdet med at udvikle løsninger til formuerådgiverne i bankerne,
                        men det kom ikke den almindelige dansker til gode. Derfor har vi taget denne løsning, og gjort den tilgængelig for alle.
                    </p>
                    <p>
                        Vores mission er at bidrage til FN’s verdensmål om at reducere økonomisk
                        ulighed på tværs af alder og køn.
                    </p>
                </ContentBoxText>
                <ContentBoxFigure className="brtl topSpace" figure="/static/gfx/content/penly-teamwork-1.jpg"></ContentBoxFigure>
            </ContentBoxContainer>

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/content/penly-teamwork-2.jpg" className="brbr"></ContentBoxFigure>
                <ContentBoxText>
                    <h3>Økonomi behøver ikke at være kedeligt</h3>
                    <p>
                        Vi kender følelsen af, at økonomi kan virke uoverskueligt eller kedeligt. Derfor har vi
                        udviklet de værktøjer, vi selv savnede til at skabe overblik over vores økonomi, så du
                        blot kan rette blikket mod resultatet. Vi tygger os igennem alle de tørre tal og giver dig
                        en konkret anbefaling til, hvordan du kan optimere din økonomi ved at ændre på nogle
                        få ting.
                    </p>
                </ContentBoxText>
            </ContentBoxContainer>

            { fromTablethori ? <Spacer size="huge" /> : <Spacer /> }

            <ContentBoxContainer className="mobileflip">
                <ContentBoxText>
                    <h3>Lad os nu være ærlige – vi vil hellere selv bruge tiden på andre ting end privatøkonomi</h3>
                    <p>
                        Selvom vi er vilde med tal, så er vi ikke begejstrede for privatøkonomi. For at være
                        ærlige vil vi hellere bruge tiden på andre ting, når nu det kan klares automatisk -
                        derfor har vi udviklet Penly.
                    </p>
                    <p>
                        Vi opdagede, hvor mange penge vi mistede ved at have f.eks. klatpensioner, der
                        svandt ind som var det kviksand, og hvor meget vi reelt kunne tjene på at omlægge
                        vores lån. Det var en øjenåbner for os.
                    </p>
                    <p>
                        Penly vil vi give dig det fulde overblik over din økonomi, og fordi vi er uvildige, er vores
                        råd ikke baseret på hvilke produkter, vi selv har på hylderne.
                    </p>
                    <p>
                        Vi vil gøre det nemt at skabe overblik over privatøkonomi, så du kan tage ejerskab
                        over din egen økonomi. Det gør dig i stand til at træffe de rette økonomiske valg ved at
                        give dig viden og indsigt om din egen økonomi og dermed få mest muligt ud af dine
                        penge. Det tror vi, giver dig den største grad af frihed.
                    </p>
                </ContentBoxText>
                <ContentBoxFigure className="brbr brtl background-highlight penlylogowhite"></ContentBoxFigure>
            </ContentBoxContainer>

            <Spacer />

            <article className="aboutPenlyWhoAreWe">
                <h2>Mød teamet</h2>
                <p>Vi er et stærkt team bestående af nysgerrige og dedikerede eksperter inden for økonomi, teknik og markedsføring.</p>
                <p>
                    Vi kommer fra vidt forskellige baggrunde, men fælles for os alle er, at vi tror på at innovative digitale løsninger og unikke algoritmer kan gøre danskerne ikke bare klogere, men
                    også mere bevidste og bedre til at træffe beslutninger om deres privatøkonomi.
                </p>

                <Spacer />

                <div>
                    <div className="team">
                        <img src="/static/gfx/PenlyFamily/ThePenlyFamily.jpg" alt="Meet the Penly Team" className="brbr brtl" />
                    </div>

                    <Spacer />

                    <ul>
                        <li className="brtl">
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-KouroshMarjaniRasmussen.jpg" alt="Kourosh Marjani Rasmussen, Penly CEO" />
                            <div>
                                <strong>Kourosh Marjani Rasmussen</strong>
                                <span>CEO</span>
                                <a href="mailto:kourosh@penly.dk">kourosh@penly.dk</a>
                                <a href="tel:+4540866164">+45 40 86 61 64</a>
                                <span>Du kan ringe til os tirsdag og torsdag mellem 10.00 og 14.00.</span>
                            </div>
                        </li>

                        <li>
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-MichaelAgerCarlsen.jpg" alt="Michael Ager Carlsen, Penly Commercial Manager" />
                            <div>
                                <strong>Michael Ager Carlsen</strong>
                                <span>Commercial Manager</span>
                                <a href="mailto:michael@penly.dk">michael@penly.dk</a>
                            </div>
                        </li>

                        <li>
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-AsbjoernDyhrbergThegler.jpg" alt="Asbjørn Dyhrberg Thegler, Penly CTO &amp; DPO" />
                            <div>
                                <strong>Asbjørn Dyhrberg Thegler</strong>
                                <span>CTO, DPO &amp; Developer</span>
                                <a href="mailto:asbjoern@penly.dk">asbjoern@penly.dk</a>
                            </div>
                        </li>

                        <li>
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-CarinaRisbjergJohnsen.jpg" alt="Carina Risbjerg Johnsen, Penly Marketing Lead" />
                            <div>
                                <strong>Carina Risbjerg Johnsen</strong>
                                <span>Marketing Lead</span>
                                <a href="mailto:carina@penly.dk">carina@penly.dk</a>
                            </div>
                        </li>
                        <li>
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-UlrikKristianEiring.jpg" />
                            <div>
                                <strong>Ulrik Eiring</strong>
                                <span>Product Manager</span>
                                <a href="mailto:ulrik@penly.dk">ulrik@penly.dk</a>
                            </div>
                        </li>

                        <li>
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-EmilAhlmannOestergaard.jpg" alt="Emil Ahlmann Østergaard, Penly Product Manager" />
                            <div>
                                <strong>Emil Ahlmann Østergaard</strong>
                                <span>Product Manager</span>
                                <a href="mailto:emil@penly.dk">emil@penly.dk</a>
                            </div>
                        </li>

                        <li>
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-JakobGoettrupNielsen.jpg" alt="Jakob Gøttrup Nielsen, Penly Developer" />
                            <div>
                                <strong>Jakob Gøttrup Nielsen</strong>
                                <span>Developer</span>
                                <a href="mailto:jakob@penly.dk">jakob@penly.dk</a>
                            </div>
                        </li>

                        <li>
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-EddiSoegaard.jpg" alt="Eddi Søgaard, Penly Mathematical Developer" />
                            <div>
                                <strong>Eddi Søgaard</strong>
                                <span>Mathematical Developer</span>
                                <a href="mailto:eddi@penly.dk">eddi@penly.dk</a>
                            </div>
                        </li>

                        <li >
                            <img src="/static/gfx/PenlyFamily/ThePenlyFamily-AndersHauerslevRosten.jpg" alt="Anders Hauerslev Rostén, Penly Developer &amp; UX Lead" />
                            <div>
                                <strong>Anders Hauerslev Rostén</strong>
                                <span>Developer &amp; UX Lead</span>
                                <a href="mailto:anders@penly.dk">anders@penly.dk</a>
                            </div>
                        </li>
                    </ul>
                    <Spacer />

                    <h3>Rådgivere</h3>

                    <ul className="advisors">
                        <li className="">
                            <img src="/static/gfx/content/advisors/2.jpg" />
                            <div>
                                <strong>Trine Sund Kammersgaard</strong>
                                <span>Pensionsrådgiver</span>
                                <a href="mailto:trine@penly.dk">trine@penly.dk</a>
                            </div>
                        </li>
                        <li className="">
                            <img src="https://storage.googleapis.com/penly-strapi/Tom_Clausen_Pensionsraadgiver_6631fe2d32.jpg" />
                            <div>
                                <strong>Tom Clausen</strong>
                                <span>Pensionsrådgiver</span>
                                <a href="mailto:tom@penly.dk">tom@penly.dk</a>
                            </div>
                        </li>
                        <li className="">
                            <img src="/static/gfx/content/advisors/1.jpg" />
                            <div>
                                <strong>Søren Risager Rasmussen</strong>
                                <span>Investeringsrådgiver</span>
                                <a href="mailto:soren@penly.dk">soren@penly.dk</a>
                            </div>
                        </li>
                        <li className="brbr">
                            <img src="https://storage.googleapis.com/penly-strapi/Henrik_Rasmussen_Investeringsraadgiver_9bd1ec6d7c.jpg" />
                            <div>
                                <strong>Henrik Rasmussen</strong>
                                <span>Investeringsrådgiver</span>
                                <a href="mailto:henrik@penly.dk">henrik@penly.dk</a>
                            </div>
                        </li>
                    </ul>

                    <Spacer />

                    { /* Hos Penly prioriterer vi uafhængig og kompetent pensionsrådgivning højt. Derfor samarbejder vi nu med Tom Clausen fra Nordic Insure, som har mange års erfaring med at rådgive både selvstændige og lønmodtagere om pension og forsikringer.

Tom er autoriseret forsikringsmægler med en baggrund i den finansielle sektor siden 1886. Han har specialiseret sig i at hjælpe kunder med at få overblik over deres pensionsforhold og finde skræddersyede løsninger, der matcher både deres livssituation og fremtidsplaner. Du kan se tilladelsen til Nordic Insure på Finanstilsynets hjemmeside her. (https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=228540E3-56D8-E811-813C-00505680286D
)

Toms tilgang er Penlys tilgang
Vi deler missionen om at gøre det lettere for danskerne at få mest muligt ud af deres pensionsopsparing. Tom arbejder målrettet på at skabe gennemsigtighed og værdi i rådgivningen. */ }
                </div>
            </article>
        </>
    );
}
